import React, { useEffect, useState } from "react";

const NcInputNumber = ({
  className = "w-full",
  defaultValue = 0,
  min = 0,
  max,
  onClick = () => {},
  label,
  desc,
  isBlocked,
}) => {
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  // const handleClickDecrement = () => {
  //   if (min >= value) return;
  //   setValue((state) => {
  //     return state - 1;
  //   });
  //   onClick && onClick(value - 1);
  // };
  // const handleClickIncrement = () => {
  //   if (max && max <= value) return;
  //   setValue((state) => {
  //     return state + 1;
  //   });
  //   onClick && onClick(value + 1);
  // };

  const renderLabel = () => {
    return (
      <div className="flex flex-col">
        <span className="font-medium text-neutral-800 dark:text-neutral-200">
          {label}
        </span>
        {desc && (
          <span className="text-xs text-neutral-500 dark:text-neutral-400 font-normal">
            {desc}
          </span>
        )}
      </div>
    );
  };

  return (
    <button
      className={` flex items-center justify-between space-x-5 ${className} ${
        isBlocked && "text-gray-400 line-through cursor-not-allowed"
      }`}
      onClick={(e) => {
        !isBlocked && onClick(defaultValue);
        e.preventDefault();
      }}
      disabled={isBlocked}
    >
      {label && renderLabel()}
    </button>
  );
};

export default NcInputNumber;
